import { useContext, useEffect, useState } from 'react';
import glo from '../../../../assets/Glo.svg';
import { AuthContext } from '../../../../context/authContext';
// import { inputBorder } from '../../../post advert/components/data';
import { getDataPlans } from '../../service/dataPlans';
import DataPayment from './DataPayment';
import useBuyData from './useBuyData';

const GloDataPayment = () => {
  const { userInfo } = useContext(AuthContext);
  const { userId } = userInfo;
  const [dataPlans, setDataPlans] = useState([]);

  useEffect(() => {
    getDataPlans(userId, setDataPlans);
  }, [userId]);

  const removeWords = (word) => `${word.split(' ').slice(1, 4).join('')})`;

  const filterDataPlansithLabel = () => {
    return dataPlans
      .filter((plan) => plan.provider === 'GLO')
      .map((m) => ({ ...m, label: removeWords(m.name) }));
  };

  const {
    handleDataSubscription,
    setMobileNumber,
    mobileNumber,
    selectedOption,
    setSelectedOption,
    loading,
    success,
  } = useBuyData();

  return (
    <DataPayment
      logo={glo}
      sucess={success}
      dataPlans={filterDataPlansithLabel()}
      selectedOption={selectedOption}
      setSelectedOption={setSelectedOption}
      setMobileNumber={setMobileNumber}
      mobileNumber={mobileNumber}
      handleDataSubscription={() => handleDataSubscription(2)}
      loading={loading}
    />
  );
};

export default GloDataPayment;
